module.exports = __webpack_public_path__ + "static/img/16c.82be9b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/16c.jpg
// module id = qzT0
// module chunks = 0